import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "./api";
import "./Temp.css";
import { Select } from "@mui/material";
import { Form, Input, Button, message } from "antd";

function Temp() {

  const generateId = () => Array.from({length: 6}, () => {
    return "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(Math.random() * 36)];
    }).join("")
 
  


  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("vendor");
  const [vendorId, setVendorId] = useState(generateId());
  const [vendorName, setVendorName] = useState("");
  const [vendorAddress, setVendorAddress] = useState("");
  const [gstIn, setGstIn] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setmobile] = useState("");
  const [phone, setphone] = useState("");
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState('');




  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isGstUnique, setIsGstUnique] = useState(false);
  const [isUsernameUnique, setIsUsernameUnique] = useState(false);

  const openPopup = async () => {
    const usernameData = await axios.post("https://dev.digitalexamregistration.com/api/checkUsername", {username})
    if (usernameData.data.isUsernameUnique) {
      setIsUsernameUnique(true);
    }else {
      setIsUsernameUnique(false)
    }

    const gstData = await axios.post("https://dev.digitalexamregistration.com/api/checkGst", {gstIn})
    if (gstData.data.isGstUnique) {
      setIsGstUnique(true);
    }else {
      setIsGstUnique(false);
    }
    


    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setIsLoading(false);
  };





  useEffect(() => {
    fetch('https://raw.githubusercontent.com/nshntarora/Indian-Cities-JSON/master/cities.json')
      .then(response => response.json())
      .then(data => {
        const stateCityMap = {};


        data.forEach(city => {
          if (stateCityMap[city.state]) {
            stateCityMap[city.state].push({ name: city.name, code: city.id });
          } else {
            stateCityMap[city.state] = [{ name: city.name, code: city.id }];
          }
        });

        const statesArray = Object.keys(stateCityMap).map((stateName, index) => ({
          name: stateName,
          code: index.toString().padStart(2, '0'),
          cities: stateCityMap[stateName],
        }));

        setStates(statesArray);

        // console.log(statesArray)
      })
      .catch(error => console.error('Error fetching city data:', error));
  }, []);

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setSelectedState(selectedState);
    const state = states.find(s => s.name === selectedState);
    setCities(state ? state.cities : []);
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setSelectedCity(selectedCity);
  };


  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Example of handling login response
  const handleSignup = async (e) => {
    e.preventDefault();

    if (!isGstUnique || !isUsernameUnique) {
      return;
    }

    setIsLoading(true); // Set loading state to true while making the request
    setError(null); // Reset error message if any


    try {
      const requestData = {
        username,
        password,
        role,
        email,
        mobile,
        phone,
        vendorId,
        vendorName,
        vendorAddress,
        state: selectedState,
        city: selectedCity,
        gstIn,
        paymentModes: {
    cod: true,
    online: false
  }
      }

      // if (!username || !password || !role || !email || !mobile || !selectedCity || !vendorId|| !vendorName || !vendorAddress || !selectedState  ) {
      //   message.error("All fields (username, password, email, mobile, city, vendorName, vendorAddress, state) are required")
      //   return;
      // }

      const vendorManagementResponse = await axios.post("https://dev.digitalexamregistration.com/api/addVendor", requestData);

      console.log(vendorManagementResponse)
      
      const data = vendorManagementResponse?.data?.vendor;

      console.log(data, "vendor data")
      
      if (!data?._id) {
        message.error("Distributor Creation Failed.")
        return;
      }

      message.success("Distributor details added successfully!");

      const requestUserData = {
        username,
        password,
        role,
        vendorId: data?._id
      }

      const userResponse = await axios.post("https://dev.digitalexamregistration.com/api/addUser", requestUserData);

      if (userResponse.status === 201) {
        message.success("User details added successfully!");
        navigate('/login')
      } else {
        console.error("Enter unique username")
        return;
      }

    } catch (error) {
      setVendorId(generateId())
      console.error("Error:", error.response?.data || error.message);
      message.error(error?.response?.data?.error);
      setIsLoading(false); 
    }
  };



  return (
    <div className="signup-container">
      <div className="signup-card">
        <h2 className="signup-heading">Welcome Back!</h2>
        <p className="signup-subheading">Please sign up to your account</p>
        <form className="signup-form">
          <div className="form-field">
            <label htmlFor="username" className="form-label">
              Username<span style={{color: "red"}}>*</span>
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              placeholder="Enter your username"
              className="form-input"
              aria-label="Username"
              maxlength="25"
            />
          </div>
          <div className="form-field">
            <label htmlFor="password" className="form-label">
              Password<span style={{color: "red"}}>*</span>
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
              className="form-input"
              aria-label="Password"
              maxlength="25"
            />
          </div>
          <div className="form-field">
            <label htmlFor="vendorName" className="form-label">
              Name<span style={{color: "red"}}>*</span>
            </label>
            <input
              type="text"
              id="vendorName"
              value={vendorName}
              onChange={(e) => setVendorName(e.target.value)}
              required
              placeholder="Enter Distributor's Name"
              className="form-input"
              aria-label="vendorName"
              maxlength="25"
            />
          </div>
          <div className="form-field">
            <label htmlFor="vendorAddress" className="form-label">
              Address<span style={{color: "red"}}>*</span>
            </label>
            <input
              type="text"
              id="vendorAddress"
              value={vendorAddress}
              onChange={(e) => setVendorAddress(e.target.value)}
              required
              placeholder="Enter Distributor's Address"
              className="form-input"
              aria-label="vendorAddress"
              maxlength="150"
            />
          </div>
          <div className="form-field">
            <label htmlFor="state" className="form-label">
              State<span style={{color: "red"}}>*</span>
            </label>

            <select className="form-input" name="state" id="state" onChange={(e) => handleStateChange(e)} value={selectedState}>
            {!selectedState && (<option>
              select state
            </option>)}
            {states.map((state) => (
            <option key={state.code} value={state.name}>
              {state.name}
            </option>
          ))}
            </select>
          </div>
          <div className="form-field">
            <label htmlFor="city" className="form-label">
              City<span style={{color: "red"}}>*</span>
            </label>

            <select className="form-input" name="city" id="city" onChange={(e) => handleCityChange(e)} value={selectedCity}>
            
            {!selectedCity && (
              <option>select city</option>
            )

            }
            {cities.map((city) => (
            <option key={city.code} value={city.name}>
              {city.name}
            </option>
          ))}
            </select>
          </div>
          <div className="form-field">
            <label htmlFor="email" className="form-label">
              Email ID <span style={{color: "red"}}>*</span>
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter Email ID"
              className="form-input"
              aria-label="email"
              maxlength="35"
            />
          </div>
          <div className="form-field">
            <label htmlFor="mobile" className="form-label">
              Mobile Number (+91) <span style={{color: "red"}}>*</span>
            </label>
            <input
              type="text"
              id="mobile"
              value={mobile}
              onChange={(e) => setmobile(e.target.value)}
              required
              placeholder="Enter Phone number"
              className="form-input"
              aria-label="mobile"
              maxlength="10"
            />
          </div>

          <div className="form-field">
            <label htmlFor="gstIn" className="form-label">
            GSTIN/UIN 
            </label>
            <input
              type="text"
              id="gstIn"
              value={gstIn}
              onChange={(e) => setGstIn(e.target.value.toUpperCase())}
              required
              placeholder="Enter Distributor's GSTIN"
              className="form-input"
              aria-label="gstIn"
              maxlength="15"
            />
          </div>
          
          <div className="form-field">
            <label htmlFor="phone" className="form-label">
              Contact Number
            </label>
            <input
              type="text"
              id="phone"
              value={phone}
              onChange={(e) => setphone(e.target.value)}
              required
              placeholder="Enter telephone number"
              className="form-input"
              aria-label="phone"
              maxlength="10"
            />
          </div>
          
          
        </form>


        <div className="aligin-center">
          {error && <p className="error-message">{error}</p>}
          <button type="submit" onClick={openPopup} className="signup-button" disabled={isLoading}>
            {isLoading ? "Signing in..." : "Sign Up"}
          </button>
          <p class="text-xs text-muted-foreground">Already have an account? <span onClick={() => navigate("/")} class="sign-up">Login</span>
          </p>
        </div>


        <div>
          {/* <button onClick={openPopup}>Open Popup</button> */}
          {isPopupOpen && (
            <div className="popup">
              <div className="popup-content">
                <h2>Verify Details</h2>
                <p>If all details are filled correctly then click on "Confirm" Button.</p>
                {!isUsernameUnique &&  <p style={{color: "red"}}>username should be unique</p>}
                {!isGstUnique && <p style={{color: "red"}}> gst shoud be unique</p>}
                <div style={{display: "flex", flexDirection: "row", gap: "55%", paddingLeft: "30px", paddingRight: "30px"}}>
                <Button style={{backgroundColor: "#34a8eb", color: "white"}}  onClick={closePopup}>Edit</Button>
                <Button style={{backgroundColor: "#5ceb34", color: "white"}} onClick={handleSignup}>Confirmed</Button>
                </div>
              </div>
            </div>
          )}
        </div>


      </div>
    </div>
  );
}

export default Temp;



//   useEffect(() => {
//     const vendorId = localStorage.getItem("vendorId");
//     if (!vendorId) {
//       message.error("Vendor ID not found in local storage!");
//       return;
//     }

//     const fetchSettings = async () => {
//       try {
//         const res = await axios.get(`${baseURL}/billSettings/${vendorId}`);
//         if (res.data) {
//           const settings = res.data;
//           // ✅ Now form is defined, we can safely call setFieldsValue
//           form.setFieldsValue({
//             vendorName: settings.fields.vendorName,
//             display_vendorName: settings.display.vendorName,
//             vendorAddress: settings.fields.vendorAddress,
//             display_vendorAddress: settings.display.vendorAddress,
//             city: settings.fields.city,
//             display_city: settings.display.city,
//             state: settings.fields.state,
//             display_state: settings.display.state,
//             gstIn: settings.fields.gstIn,
//             display_gstIn: settings.display.gstIn,
//             mobile: settings.fields.mobile,
//             display_mobile: settings.display.mobile,
//             billWithoutGst: settings.display.billWithoutGst,
//           });

//           setLogoUrl(settings.logoUrl || "");
//           setLogoDisplay(settings.display.logo);
//           setVendorDetails(settings);
//         }
//       } catch (err) {
//         console.error("❌ Error fetching settings:", err);
//         message.error("Failed to fetch bill settings.");
//       }
//     };

//     fetchSettings();
//   }, [form]);// removed [form] if form is not defined here

// const handlePrintBill = () => {
//   if (!vendorDetails) {
//     alert("Vendor details not loaded yet!");
//     return;
//   }

//   const d = vendorDetails.display || {};
//   const f = vendorDetails.fields || {};

//   const logoHtml = d.logo && vendorDetails.logoUrl ? `<img src="${vendorDetails.logoUrl}" class="logo" /><br/>` : "";
//   const nameHtml = d.vendorName ? `<strong>${f.vendorName || ""}</strong><br/>` : "";

//   const addressParts = [];
//   if (d.vendorAddress) addressParts.push(f.vendorAddress || "");
//   if (d.city) addressParts.push(f.city || "");
//   if (d.state) addressParts.push(f.state || "");
//   const addressHtml = addressParts.length > 0 ? `${addressParts.join(", ")}<br/>` : "";

//   const gstHtml = d.gstIn ? `GST No: ${f.gstIn || ""}<br/>` : "";
//   const contactHtml = d.mobile ? `Contact: ${f.mobile || ""}` : "";

//   const invoiceNo = localStorage.getItem("orderId") || "0001";
//   const currentDate = new Date().toLocaleDateString("en-GB");
//   const currentTime = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
//   const modeOfPayment = "Cash";

//   const subTotal = subtotal.toFixed(2);
//   const grandTotal = parseFloat(subTotal).toFixed(2);

//   const itemRows = cart
//     .map((item) => {
//       const itemTotal = (item.price * item.quantity).toFixed(2);
//       return `
//         <tr>
//           <td>${item.name}</td>
//           <td style="text-align:right;">₹${item.price}</td>
//           <td style="text-align:center;">${item.quantity}</td>
//           <td style="text-align:right;">₹${itemTotal}</td>
//         </tr>`;
//     })
//     .join("");

//   const billContent = `
//     <html>
//       <head>
//         <title>Bill</title>
//         <style>
//           body { font-family: Arial, sans-serif; padding: 20px; }
//           .logo { max-height: 60px; margin-bottom: 10px; }
//           h2, h3, p { margin: 4px 0; text-align: center; }
//           table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 14px; }
//           th, td { padding: 6px; border-bottom: 1px dashed #000; }
//           th { text-align: left; }
//           .totals td { border: none; }
//           .footer { text-align:center; margin-top:20px; font-size:12px; color:gray; }
//         </style>
//       </head>
//       <body>
//         <div style="text-align:center;">
//           ${logoHtml}
//           ${nameHtml}
//           ${addressHtml}
//           ${gstHtml}
//           ${contactHtml}
//         </div>
//         <hr/>
//         <div style="display:flex; justify-content:space-between; margin-top:8px;">
//           <div>Invoice No: ${invoiceNo}</div>
//           <div>Date: ${currentDate}</div>
//         </div>
//         <table>
//           <thead>
//             <tr>
//               <th>Item</th>
//               <th style="text-align:right;">Price</th>
//               <th style="text-align:center;">Qty</th>
//               <th style="text-align:right;">Total</th>
//             </tr>
//           </thead>
//           <tbody>
//             ${itemRows}
//           </tbody>
//         </table>
//         <table style="margin-top:10px;">
//           <tr class="totals"><td colspan="3" style="text-align:right;">Sub-Total:</td><td style="text-align:right;">₹${subTotal}</td></tr>
//           <tr class="totals"><td colspan="3" style="text-align:right; font-weight:bold;">Total:</td><td style="text-align:right; font-weight:bold;">₹${grandTotal}</td></tr>
//           <tr class="totals"><td colspan="3" style="text-align:right;">Mode:</td><td style="text-align:right;">${modeOfPayment}</td></tr>
//         </table>
//         <div class="footer">
//           **SAVE PAPER SAVE NATURE !!**<br/>
//           Time: ${currentTime}
//         </div>
//       </body>
//     </html>`;

//   const printWindow = window.open("", "_blank");
//   printWindow.document.write(billContent);
//   printWindow.document.close();
//   printWindow.focus();
//   printWindow.print();
// };
